import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {PieChartData} from "../../../models/charts/PieChartData";
import Chart from "chart.js";
import {ChartConfig} from "../../../utils/chartConfig";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-multiple-pie-chart',
  templateUrl: './multiple-pie-chart.component.html',
  styleUrls: ['./multiple-pie-chart.component.scss']
})
export class MultiplePieChartComponent implements OnChanges {
  @Input() chartData:PieChartData;
  public total:number = 0;
  private canvas;
  private ctx;
  public chart:Chart;

  constructor(private translateService: TranslateService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.chartData != undefined) {
      if(changes.chartData.firstChange){
        this.canvas = document.getElementById(this.chartData.canvasElementId).getElementsByTagName("canvas")[0];
        this.ctx = this.canvas.getContext("2d");
      }

      this.updateSum();

      let config = ChartConfig.getPieChartConfig(this.chartData.data, this.chartData.colors);
      this.chartData.chartLabels.forEach((label, index) => {
        config.data.labels.push(label);
        this.translateService.get(label).subscribe((text: string) => {
          config.data.labels[index] = text;
        });
      });

      this.chart = new Chart(this.ctx, config);
    }
  }

  updateSum(){
    this.total = 0;
    for(let data of this.chartData.data){
      this.total += data;
    }
  }
}
